export enum HallowABFlag {
  WebFirstMonthFreeText = "web_first_month_free_text",
  WebFoundingStory = "web_founding_story",
  WebMediumOnboarding = "web_medium_onboarding",
  WebStrikethrough = "web_strikethrough_text",
  WebHomepageCTADestination = "web_homepage_cta_destination",
}
